import RansomwareImg from "public/ransomwareProtection/ransomware.svg";
import DdosImg from "public/ransomwareProtection/ddos.svg";
import ZtnaImg from "public/ransomwareProtection/ztna.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: RansomwareImg,
    title: "Ransomware Protection",
    text: " Powered by Sophos Intercept X and ESET, OneMind uses AI-driven behavioral analysis to detect and block fileless malware, zero-day exploits, & encryption-based extortion. Infected systems are auto isolated and restored with rollback.",
  },
  {
    image: DdosImg,
    title: "DDoS Mitigation",
    text: "Using Fortinet, Palo Alto, Juniper, and AT&T’s secure network edge, OneMind detects and filters out volumetric and application-layer DDoS attacks in real time — with geo-blocking, rate limiting, and intelligent traffic shaping.",
  },
  {
    image: ZtnaImg,
    title: "Zero Trust Network Access",
    text: "Through policy enforcement from Check Point and Cisco Secure Access, OneMind ensures least-privilege access, strict device verification, and multi-factor authentication — reducing lateral movement and insider threat risk.",
  },
];
